import AddCheckedPhoto from "components/CustomUpload/AddCheckedPhoto";
import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Form,
  Input,
  Row,
} from "reactstrap";
import ApiContext from "services/ApiContext";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import "../sales.css";
import Switch from "react-ios-switch/lib/Switch";
import ShopContext from "services/ShopContext";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function AddNewMerchandise() {
  const shopID =
    useContext(ShopContext).selctShopID &&
    useContext(ShopContext).selctShopID.ID;
  const Axios = useContext(ApiContext);
  const history = useHistory();
  const [malayName, setMalayName] = useState("");
  const [malayDesp, setMalayDesp] = useState("");
  const [englishName, setMEnglishName] = useState("");
  const [englishDesp, setEnglishDesp] = useState("");
  const [sku, setSKU] = useState("");
  const [price, setPrice] = useState("");
  const [count, setCount] = useState("");
  const [checked, setChecked] = useState(false);
  const [imgUpload, setImgUpload] = useState(null);
  const [file, setFile] = useState(null);

  const uploadImgCallback = (imgFile) => {
    setImgUpload(imgFile);
  };
  const uploadCombine = (img) => {
    if (img && Array.isArray(img)) {
      setFile([...img]);
    } else if (img === null) {
      setFile([]);
    }
  };

  useEffect(() => {
    uploadCombine(imgUpload);
  }, [imgUpload]);

  const handleBackClick = () => {
    history.goBack();
  };
  const validationSchema = Yup.object().shape({
    MalName: Yup.string().required("MalayName Required"),
    EngName: Yup.string().required("MalayName Required"),
    MalDescription: Yup.string().required("MalDescription Required"),
    EngDescription: Yup.string().required("EngDescription Required"),
    StockCount: Yup.string().required("StockCount Required"),
    Status: Yup.string().required("MalayName Required"),
    AttachmentList: Yup.string().required("Product List  Required"),
    SKU: Yup.string().required("SKU Required"),
    Price: Yup.string().required("Price Required"),
  });
  const formik = useFormik({
    initialValues: {
      Status: "",
      StockCount: "",
      Price: "",
      MalName: "",
      EngName: "",
      SKU: "",
      MalDescription: "",
      EngDescription: "",
      AttachmentList: "",
    },
    validationSchema,
  });
  const onSubmit = (e) => {
    e.preventDefault();
    const data2 = new FormData();
    data2.append("Status", checked);
    data2.append("StockCount", count);
    data2.append("Price", price);
    data2.append("MalName", malayName);
    data2.append("EngName", englishName);
    data2.append("SKU", sku);
    data2.append("MalDescription", malayDesp);
    data2.append("EngDescription", englishDesp);

    if (file !== null) {
      file.forEach((files) => {
        data2.append("AttachmentList", files);
      });
    } else {
      data2.append("AttachmentList", []);
    }

    if (file !== null && file.length >= 1) {
      Axios.post(`/shop/${shopID}/Merchandise/CreateMerchandise`, data2)
        .then((res) => {
          toast.success(res.data[0].MESSAGE);
          formik.resetForm(); // Reset the form
        })
        .catch((error) => {
          toast.error(error.response.data[0].MESSAGE);
        });
    }
  };

  return (
    <div className="content px-3 w-100">
      <Button
        style={{ backgroundColor: "#51BCDA" }}
        className="mt-2 p-2 ml-5"
        onClick={handleBackClick}
        size="sm"
      >
        Back
      </Button>
      <Card className="card-dark" style={{ minWidth: "350px" }}>
        <CardHeader>
          <CardTitle tag="h4">Add New Merchandise</CardTitle>
        </CardHeader>
        <CardBody>
          <p className="bg-info p-2 pl-4">New Merchandise Information</p>
          <Form onSubmit={onSubmit}>
            <Row>
              <Col md="6">
                <Row className="ml-1">
                  <Col
                    md="3"
                    className="mr-1 p-2 mb-1"
                    style={{ border: "1px solid #51BCDA" }}
                  >
                    Malay Name:
                  </Col>
                  <Col
                    md="8"
                    className="p-2 l-3 mb-1"
                    style={{ border: "1px solid #51BCDA" }}
                  >
                    <Input
                      type="text"
                      value={malayName}
                      onChange={(e) => setMalayName(e.target.value)}
                    />
                  </Col>
                </Row>
                <Row className="ml-1">
                  <Col
                    md="3"
                    className="mr-1 p-2 mb-1"
                    style={{ border: "1px solid #51BCDA" }}
                  >
                    Malay Description:
                  </Col>
                  <Col
                    md="8"
                    className="p-2 l-3 mb-1"
                    style={{ border: "1px solid #51BCDA" }}
                  >
                    <Input
                      type="text"
                      value={malayDesp}
                      onChange={(e) => setMalayDesp(e.target.value)}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md="6">
                <Row className="ml-1">
                  <Col
                    md="3"
                    className="mr-1 p-2 mb-1"
                    style={{ border: "1px solid #51BCDA" }}
                  >
                    English Name:
                  </Col>
                  <Col
                    md="8"
                    className="p-2 l-3 mb-1"
                    style={{ border: "1px solid #51BCDA" }}
                  >
                    <Input
                      type="text"
                      value={englishName}
                      onChange={(e) => setMEnglishName(e.target.value)}
                    />
                    {formik.errors.MalayName ? (
                      <p className="errorText text-danger">
                        {formik.errors.englishName}
                      </p>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
                <Row className="ml-1">
                  <Col
                    md="3"
                    className="mr-1 p-2 mb-1"
                    style={{ border: "1px solid #51BCDA" }}
                  >
                    English Description:
                  </Col>
                  <Col
                    md="8"
                    className="p-2 l-3 mb-1"
                    style={{ border: "1px solid #51BCDA" }}
                  >
                    <Input
                      type="text"
                      value={englishDesp}
                      onChange={(e) => setEnglishDesp(e.target.value)}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="ml-1">
              <Col
                md="3"
                className="mr-1 p-2 mb-1"
                style={{ border: "1px solid #51BCDA" }}
              >
                Status:
              </Col>
              <Col
                md="8"
                className="p-2 mb-1"
                style={{ border: "1px solid #51BCDA" }}
              >
                <div>
                  {checked && <span>Activated</span>}
                  <Switch
                    checked={checked}
                    onChange={() => {
                      setChecked(!checked);
                    }}
                  />
                  {!checked && <span>Deactivated</span>}
                </div>
                {formik.errors.ShopSKU ? (
                  <p className="errorText text-danger">
                    {formik.errors.ShopSKU}
                  </p>
                ) : (
                  ""
                )}
              </Col>
            </Row>
            <Row className="ml-1">
              <Col
                md="3"
                className="mr-1 p-2 mb-1"
                style={{ border: "1px solid #51BCDA" }}
              >
                SKU:
              </Col>
              <Col
                md="8"
                className="p-2 mb-1"
                style={{ border: "1px solid #51BCDA" }}
              >
                <Input
                  type="text"
                  value={sku}
                  onChange={(e) => setSKU(e.target.value)}
                />
                {formik.errors.ShopSKU ? (
                  <p className="errorText text-danger">
                    {formik.errors.ShopSKU}
                  </p>
                ) : (
                  ""
                )}
              </Col>
            </Row>
            <Row className="ml-1">
              <Col
                md="3"
                className="mr-1 p-2 mb-1"
                style={{ border: "1px solid #51BCDA" }}
              >
                Photos:
              </Col>
              <Col
                md="8"
                className="p-2 mb-1"
                style={{ border: "1px solid #51BCDA" }}
              >
                <AddCheckedPhoto uploadImgCallback={uploadImgCallback} />
                {formik.errors.AttachmentList ? (
                  <p className="errorText text-danger">
                    {formik.errors.AttachmentList}
                  </p>
                ) : (
                  ""
                )}
              </Col>
            </Row>
            <Row className="ml-1">
              <Col
                md="3"
                className="mr-1 p-2 mb-1"
                style={{ border: "1px solid #51BCDA" }}
              >
                Stock Count:
              </Col>
              <Col
                md="8"
                className="mr-1 p-2 mb-1"
                style={{ border: "1px solid #51BCDA" }}
              >
                <Input
                  type="text"
                  value={count}
                  onChange={(e) => setCount(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="ml-1">
              <Col
                md="3"
                className="mr-1 p-2 mb-1"
                style={{ border: "1px solid #51BCDA" }}
              >
                Price(RM):
              </Col>
              <Col
                md="8"
                className="mr-1 p-2 mb-1"
                style={{ border: "1px solid #51BCDA" }}
              >
                <Input
                  type="text"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="text-left pt-2 font-weight-bold ">
              <Col sm="12">
                <div className="text-center">
                  <Button className="btn-md btn-success" type="submit">
                    Create Merchandise
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
}

export default AddNewMerchandise;
